export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_BASE_URL = BASE_URL + '/api'
export const PUBLIC_BASE_URL = BASE_URL + '/public';
export const KEYCLOAK_AUTH_URL = 'https://login.fivefaces.com.au/auth';
export const DEFAULT_LOGO = "https://files.fivefaces.com.au/images/FiveFaces_Logo_Navy.svg"
export const POWERED_BY_LOGO = "https://files.fivefaces.com.au/images/FiveFaces_PoweredBy_Navy.svg"
export const QUERY_API_URL = "https://ms-teams-poc.fftest.com.au";
